import request from '@/utils/request'

// 获取新闻列表
export function newsList(data) {
  return request({
    url: '/news/list',
    method: 'post',
    data: data
  })
}

// 获取新闻详情
export function newsInfo(data) {
  return request({
    url: '/news/info',
    method: 'get',
    params: data
  })
}

// 获取所有新闻（不带分页，用于选择）
export function newsAll(data) {
  return request({
    url: '/news/all',
    method: 'get',
    params: data
  })
}

// 新闻新增
export function newsAdd(data) {
  return request({
    url: '/news/add',
    method: 'post',
    data
  })
}

// 新闻编辑
export function newsEdit(data) {
  return request({
    url: '/news/edit',
    method: 'put',
    data
  })
}

// 新闻删除
export function newsDelete(data) {
  return request({
    url: '/news/delete',
    method: 'delete',
    params: data
  })
}
